const RevealEffects = () => {

  const options = {
    root: null,
    rootMargin: "0px",
    threshold: 0.4
  };

  let fadeupCallback = (entries) => {
    entries.forEach((entry) => {
      let container = entry.target;
      container.classList.add("not-fading-up");

      if (entry.isIntersecting) {
        container.classList.add("fading-up");
        return;
      }

    });
  };

  let fadeupObserver = new IntersectionObserver(fadeupCallback, options);


  let zoomOutCallback = (entries) => {
    entries.forEach((entry) => {
      let container = entry.target;
      container.classList.add("not-zooming-out");

      if (entry.isIntersecting) {
        container.classList.add("zooming-out");
        return;
      }

    });
  };
  let zoomOutObserver = new IntersectionObserver(zoomOutCallback, options);

  document.querySelectorAll(".fadeup, .selected-posts, .wp-block-media-text__content, .wp-block-column, .wp-block-group__inner-container > p, .wp-block-group__inner-container > .wp-block-image, .wp-block-group__inner-container > h1, .wp-block-group__inner-container > h2, .wp-block-group__inner-container > h3, .wp-block-group__inner-container > h4, .wp-block-group__inner-container > h5").forEach((el) => {
    fadeupObserver.observe(el);
  });

  document.querySelectorAll(".is-style-50-50-edge .wp-block-media-text__media img").forEach((el) => {
    zoomOutObserver.observe(el);
  });

}

export default RevealEffects;